module.exports = __webpack_public_path__ + "img/charkhoune.7fe42d6d.png";